import React, {useState, useMemo} from "react"
import {useDispatch, useStore} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"
import {useCookies} from "react-cookie"
import {useOnUpdate} from "../hooks"
import {loadBaseDate} from "../lib/LoadValues"

export default function SelectTerm({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const [cookies] = useCookies([])
  const [key, setKey] = useState(false)
  const {
    store: {locale, perspective, mainTerm, mainTarget, mainGroup, termIds, termList},
  } = useStore()

  const useMainTerm = () => {
    setKey(!key)
  }
  useOnUpdate(useMainTerm, [locale])

  const handleChange = async (value) => {
    if (!value && id === termIds[perspective]) {
      mainTerm[perspective].key = null
      mainTerm[perspective].label = ``
      dispatch({
        type: `SET_MAIN_TERM`,
        mainTerm,
      })
      return
    }
    if (!value) return
    mainTerm[perspective].key = value.key
    mainTerm[perspective].label = t(value.key) /* i18next-extract-disable-line */
    mainTerm[perspective].labelJa = value?.labelJa ?? value?.labelJa
    mainTerm[perspective].labelEn = value?.labelEn ?? value?.labelEn
    dispatch({
      type: `SET_MAIN_TERM`,
      mainTerm,
    })
    dispatch({
      type: `Z_INDEX`,
      zIndex: `term`,
    })

    let group = mainGroup[perspective]
    let term = mainTerm[perspective].key
    let code = mainTarget[perspective].key
    await loadBaseDate(group, term, code, cookies, dispatch)
  }

// Nakamura Memo : なぜか初回表示の直後に言語を切り替えるとおかしくなるので、useMemo の使用をやめる。
//                 動作上の遅延は特に見受けられない（無駄はあるかもしれないが）。
/*
  return useMemo(() => (
    <VirtualSelect
      id={id}
      key={key}
      required={true}
      target={`term`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={t(`comparisonTerm`)}
      options={termList[perspective]}
      onChange={handleChange}
      value={mainTerm[perspective]}
    />
  ), [locale, termList, mainTerm, perspective])
*/
  return (
    <VirtualSelect
      id={id}
      key={key}
      required={true}
      target={`term`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={t(`comparisonTerm`)}
      options={termList[perspective]}
      onChange={handleChange}
      value={mainTerm[perspective]}
    />
  )
}
